import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// accounts/actions_log — data-controller="account--action-log"
export default class extends Controller {
  static targets = ["table", "filterWrapper", "minDate", "maxDate", "searchType", "searchModule", "paramsDialog", "paramsJson"]

  static values = {
    ajaxUrl: { type: String, default: "/actions_log" },
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    if (this.hasMinDateTarget) $("#min").off(".actionLog").datepicker("destroy")
    if (this.hasMaxDateTarget) $("#max").off(".actionLog").datepicker("destroy")
    if (this.hasSearchTypeTarget) $(this.searchTypeTarget).off(".actionLog")
    if (this.hasSearchModuleTarget) $(this.searchModuleTarget).off(".actionLog")
    $(this.tableTarget).off(".actionLog")
  }

  showRequestParams(event) {
    event.preventDefault()
    const params = event.currentTarget.dataset.requestParams
    if (!params) return

    $(this.paramsDialogTarget).dialog({
      modal: true,
      title: "Request parameters",
      hide: "fadeOut",
      show: "fadeIn",
      draggable: false,
      resizable: false,
      width: 460,
      open: () => {
        const parsed = JSON.parse(unescape(params))
        $(this.paramsJsonTarget).val(JSON.stringify(parsed, null, "\t"))
      },
      close: () => {
        $(this.paramsDialogTarget).dialog("destroy")
        $(this.paramsJsonTarget).val("")
      },
    })
  }

  filterChanged = () => {
    if (this.dataTable) this.dataTable.fnDraw(true)
  }

  dateChanged = () => {
    if (this.dataTable) this.dataTable.fnDraw()
  }

  #initDataTable() {
    const $table = $(this.tableTarget)

    this.dataTable = createTurboDataTable($table, {
      sDom: '<"H"lr<"head-toolbar">><"datatable-scroll"t><"F"<"toolbar">ipr>',
      sPaginationType: "full_numbers",
      bProcessing: true,
      bServerSide: true,
      bJQueryUI: true,
      bAutoWidth: false,
      bSortClasses: false,
      aaSorting: [[7, "desc"]],
      sAjaxSource: this.ajaxUrlValue,
      fnServerParams: (aoData) => {
        aoData.push(
          { name: "minDate", value: $("#min").datepicker("getDate") },
          { name: "maxDate", value: $("#max").datepicker("getDate") },
          { name: "searchType", value: $("#search_type").val() },
          { name: "searchModule", value: $("#search_module").val() },
        )
      },
      fnInitComplete: () => {
        $("#loading").hide()
        $table.css("width", "100%")
      },
      aoColumnDefs: [
        {
          fnRender: (oObj) => (oObj.aData[0] == null ? "none" : oObj.aData[0]),
          aTargets: [0],
        },
        {
          fnRender: (oObj) => {
            const escaped = escape(oObj.aData[3])
            return `<a href="#" data-request-params="${escaped}" data-action="click->account--action-log#showRequestParams"><span>view</span></a>`
          },
          aTargets: [3],
        },
        { bSortable: false, aTargets: [3] },
      ],
      aoColumns: [
        { sWidth: "115px" },
        { sWidth: "70px" },
        { sWidth: "50px" },
        { sWidth: "50px" },
        { sWidth: "220px" },
        null,
        null,
        null,
      ],
    }, { legacy: true })

    $(".head-toolbar").append($(this.filterWrapperTarget).remove().html())

    $("#min").datepicker()
    $("#max").datepicker()

    $(this.searchTypeTarget).on("change.actionLog", this.filterChanged)
    $(this.searchModuleTarget).on("change.actionLog", this.filterChanged)
    $("#min").on("change.actionLog", this.dateChanged)
    $("#max").on("change.actionLog", this.dateChanged)
  }
}
